import { type PoolParams, useRouteParams } from "@quortex/front-common"
import { useMatchesParams } from "@quortex/front-common/adapters/react-location"

export const useBasePath = () => {
  const { orgUuid } = useMatchesParams()
  return `/organizations/${orgUuid}/play`
}

export const usePoolPath = (params?: PoolParams) => {
  const { orgUuid, poolUuid } = useRouteParams(params)
  return `/organizations/${orgUuid}/play/pools/${poolUuid}`
}

export const useIngestBasePath = () => {
  const { orgUuid } = useMatchesParams()
  return `/organizations/${orgUuid}/ingest`
}

export const useSwitchBasePath = () => {
  const { orgUuid } = useMatchesParams()
  return `/organizations/${orgUuid}/switch`
}
